import { render, staticRenderFns } from "./FormTonsInput.vue?vue&type=template&id=0b6c16f3&scoped=true"
import script from "./FormTonsInput.vue?vue&type=script&lang=js"
export * from "./FormTonsInput.vue?vue&type=script&lang=js"
import style0 from "./FormTonsInput.vue?vue&type=style&index=0&id=0b6c16f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6c16f3",
  null
  
)

export default component.exports